import type { StaticPage } from '~/types/StaticPage';

export const useStaticPageStore = defineStore('static-page', {
  actions: {
    async getStaticPageBySlug(slug: string, skipError?: boolean) {
      try {
        const { data } = await useCustomFetch<StaticPage>(`/simple-page/${slug}`, {}, '1', skipError);

        if (data.value) {
          return data.value;
        } else {
          return null;
        }
      } catch (e) {
        if (e && process.env.NODE_ENV !== 'production') {
          console.error(e);
        }
        return null;
      }
    },
  },
});
